export default "__VITE_ASSET__I0pvDL7Q__"